import { render, staticRenderFns } from "./DichVuAmThucForm.vue?vue&type=template&id=7e28ca22&scoped=true"
import script from "./DichVuAmThucForm.vue?vue&type=script&lang=js"
export * from "./DichVuAmThucForm.vue?vue&type=script&lang=js"
import style0 from "./DichVuAmThucForm.vue?vue&type=style&index=0&id=7e28ca22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e28ca22",
  null
  
)

export default component.exports